import logoImg from "../../../assets/logo-new-white.svg";
import backgroundImg from "../../../assets/assets/BRC20Waitlist/background.svg";
import magicEden from "../../../assets/logos/magic-eden-logo.svg";
import magicEdenWallet from "../../../assets/logos/magic-eden-wallet.png";

interface MEProps {}

const ME: React.FC<MEProps> = () => {
  return (
    <div className="w-full flex md:mb-10 mb-7 justify-between  bg-[#111111] rounded-lg relative  overflow-hidden items-center sm:pr-8 pr-3 ">
      <div className="z-10 relative  sm:p-8 p-3 sm:pr-0 pr-0">
        <p className="text-white font-semibold sm:text-xl md:text-2xl text-lg">
          1.25x Points for ME Wallet is live!
        </p>
        <a
          className="cursor-pointer"
          target="_blank"
          href="https://help.magiceden.io/en/articles/8947426-magic-eden-wallet-integration-with-liquidium-for-enhanced-rewards"
        >
          <button className="bg-[#EB1F79] hover:bg-[#F94D8C] transition-colors border border-black/20 text-white font-bold p-2 py-1 rounded-md sm:mt-3 mt-2 sm:text-base text-sm cursor-pointer px-4">
            Learn more
          </button>
        </a>
      </div>
      <img
        src={logoImg}
        className=" right-0  z-10 h-[50px] md:h-[70px]"
        alt="logo-img-showcase"
      ></img>
      <img
        src={magicEdenWallet}
        className=" absolute  right-[70px] sm:right-[140px] h-[80%] sm:-mb-8 -mb-11 sm:h-full "
        alt="background-img-showcase"
      ></img>
    </div>
  );
};

export default ME;
